export default {
    CustomForm: {
        forms: [],
        formType: "",
        page: "",
        activeField: [],
        activeTabForFields: 'elements',
        themingVars: {}
    },
};